;(function () {
  'use strict'

  angular
    .module('contrast.panel-headings')
    .directive('panelHeadingTitleHelpIcon', panelHeadingTitleHelpIcon)

  function panelHeadingTitleHelpIcon() {
    return {
      restrict: 'A',
      templateUrl: 'views/panel-headings/panel-heading-title-help-icon.html'
    }
  }
})()
